import 'devextreme/dist/css/dx.common.css';
import './themes/generated/theme.base.css';
import './themes/generated/theme.additional.css';
import { BrowserRouter, Route, HashRouter as Router, Routes } from 'react-router-dom';
import './dx-styles.scss';
import LoadPanel from 'devextreme-react/load-panel';
import { NavigationProvider } from './contexts/navigation';
import { useScreenSizeClass } from './utils/media-query';
import Content from './Content';
import { licenseKey } from './devextreme-license';
import config from 'devextreme/core/config';
import { loadMessages, locale } from 'devextreme/localization';
import { AuthenticatedTemplate, MsalAuthenticationTemplate, MsalProvider, UnauthenticatedTemplate, useIsAuthenticated } from '@azure/msal-react';
import { InteractionType, IPublicClientApplication } from '@azure/msal-browser';
import itMessages from "devextreme/localization/messages/it.json";

import PublicHome from './pages/publicHome/publicHome';
import TenantProvider from './contexts/TenantProvider';
import PublicInvite from './pages/publicInvite/publicInvite';
import { InvitoPage } from './pages';
import UnauthenticatedContent from './UnauthenticatedContent';

config({ licenseKey });


type AppProps = {
  pca: IPublicClientApplication;
};

export default function Root({ pca }: AppProps) {
  const screenSizeClass = useScreenSizeClass();

  loadMessages(itMessages);
  locale(navigator.language);
  config({
    defaultCurrency: 'EUR',
    defaultUseCurrencyAccountingStyle: false
  });

  return (
    <BrowserRouter>
      <MsalProvider instance={pca}>
        <AuthenticatedTemplate>
          <NavigationProvider>
            <div className={`app ${screenSizeClass}`}>
              <Content />
            </div>
          </NavigationProvider>
        </AuthenticatedTemplate>

        <UnauthenticatedTemplate>
          <div className={`app ${screenSizeClass}`}>
            <UnauthenticatedContent />
          </div>
        </UnauthenticatedTemplate>
      </MsalProvider>
    </BrowserRouter>
  );
}

